module.exports = __webpack_public_path__ + "static/webpack-0336babb12a0ff29611fc4f3488dabd0.jpg";